/* eslint-disable react/jsx-props-no-spreading */
import PropTypes from 'prop-types';
import Checkbox from '@material-ui/core/Checkbox';
import MUIFormControlLabel from '@material-ui/core/FormControlLabel';
import styled from '@emotion/styled';
import { Spacings } from '@styles/index';

const fontGrey = 'var(--color-text-primary)';

const StyledCheckbox = styled(Checkbox)`
  &.MuiButtonBase-root {
    padding: 0px;
    padding-right: ${Spacings.SPACING_2B};
    background: none;
    color: ${({ disabled, color, checked }) => {
      if (disabled) {
        return 'var(--color-text-secondary)';
      }

      if (checked && color) {
        return color;
      }

      return fontGrey;
    }};
    .MuiIconButton-label {
      input {
        top: 0;
        left: 0;
        width: 100%;
        cursor: inherit;
        height: 100%;
        margin: 0;
        opacity: 0;
        padding: 0;
        z-index: 1;
        position: absolute;
      }
    }
  }
`;

const FormControlLabel = styled(MUIFormControlLabel)`
  color: ${({ color }) => color || fontGrey};
  &.MuiFormControlLabel-root {
    margin-left: 0px;
  }
`;

const MUICheckbox = (props) => {
  const { checked, className, label, color, size, ...data } = props;

  const checkbox = (
    <StyledCheckbox
      disableFocusRipple
      disableTouchRipple
      disableRipple
      size={size || 'small'}
      color={color || 'var(--color-text-primary)'}
      checked={checked}
      {...data}
    />
  );

  if (label)
    return (
      <FormControlLabel
        control={checkbox}
        label={label}
        color={color}
        className={className}
      />
    );

  return checkbox;
};

export default MUICheckbox;

MUICheckbox.propTypes = {
  label: PropTypes.node,
  checked: PropTypes.bool,
  color: PropTypes.string,
  onChange: PropTypes.func,
  value: PropTypes.string,
  size: PropTypes.string
};

MUICheckbox.defaultProps = {
  label: null,
  checked: false,
  color: null,
  onChange: null,
  value: null,
  size: null
};
